<script>
    import R, {LOADER} from "../lib/requests";
    import user from "../stores/user";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {SERVICE_TYPE, SERVICE_TYPES, SUBSCRIPTION_NOTIFICATIONS} from "../lib/constants";
    import PageHeader from "../components/PageHeader.svelte";
    import Breadcrumb from "../components/Breadcrumb.svelte";
    import WsServiceFields from "./WsServiceFields.svelte";
    import Select from "../components/controls/Select.svelte";
    import {acronym, randomColor, setFocusTo} from "../lib/lib";
    import ColorControl from "../components/controls/ColorControl.svelte";
    import InputGroupColor from "../components/controls/InputGroupColor.svelte";
    import WsServiceNotificationModal from "./WsServiceNotificationModal.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";

    export let serviceId = null;
    export let editCallback;

    let breadcrumb = [
        {name: `Είδη Υπηρεσιών`, link: `/app/ws-service`}
    ];

    let notificationTypes = [];
    // {type: 0, name: '1η ειδοποίηση πριν την λήξη συνδρομής', id: 0},
    // {type: 1, name: '2η ειδοποίηση πριν την λήξη συνδρομής', id: 0},
    // {type: 2, name: 'Ειδοποίηση λήξης συνδρομής', id: 0},
    // {type: 3, name: 'Ειδοποίηση ανανέωσης συνδρομής', id: 0}
    // ];

    let service = null;
    let serviceName = '';
    // let serviceTypes = [];
    let notificationType = null;
    let maxNotificationDays = null;


    const initialize = () => {
        for (let i = 0; i < 4; i++) {
            notificationTypes.push({
                type: i,
                name: SUBSCRIPTION_NOTIFICATIONS[i],
                id: 0,
            })
        }

        if (serviceId !== null) {
            if (serviceId === 0) {
                service = {
                    id: 0,
                    name: '',
                    color: randomColor(),
                    type: 0,
                    duration: 0,
                }
                serviceName = 'Νέα υπηρεσία';
            } else {
                load();
            }
        }
    }


    const load = () => {

        const onSuccess = result => {
            service = result;
            service.type = ~~service.type;
            serviceName = result.name;

            if (service.type == SERVICE_TYPE.SUBSCRIPTION) {
                service.notifications.map(item => {
                    let notification = notificationTypes.find(x => x.type == item.type);
                    notification.id = item.id;
                    notification.is_active = item.is_active;
                    notification.days_before = item.days_before;
                });
            }

            delete (service.notifications);
        }

        const onFailure = err => {
        };

        R.handle(R.ws_service.details, serviceId, onSuccess, onFailure, LOADER.PAGE);
    };

    const save = () => {
        const onSuccess = result => {
            service = result;
            editCallback(service);
            Notifier.showMessage("Η υπηρεσία ενημερώθηκε");
        }

        const onFailure = err => {
            Alert.warning("Υπηρεσία", err.message);
        };

        if (!validate()) {
            return;
        }

        let action = service.id > 0 ? 'edit' : 'create';
        R.handle(R.ws_service[action], service, onSuccess, onFailure, LOADER.POPUP);
    }


    const onEditNotification = (obj) => {
        notificationType = obj;
    }

    const closeNotification = (param) => {
        notificationType = null;

        if (param) {
            let item = notificationTypes.find(x => x.type == param.type);
            item.id = ~~param.id;
            item.days_before = param.days_before;
            item.is_active = ~~param.is_active;
            notificationTypes = notificationTypes;
        }
    }

    const onDeleteNotification = obj => {
        Alert.confirm("Διαγραφή ειδοποίησης", "Να διαγραφεί η ειδοποίηση;", () => deleteNotification(obj.id));
    }

    const deleteNotification = id => {
        const onSuccess = result => {
            let item = notificationTypes.find(x => x.id == result);
            if (item) {
                item.id = 0;
                item.days_before = null;
            }
            notificationTypes = notificationTypes;
        }

        const onFailure = err => {
        };

        R.handle(R.ws_service.notificationDelete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    const onTypeChange = () => {
        if (service.type == SERVICE_TYPE.SUBSCRIPTION && !service.duration) {
            service.duration = 12;
        }
    }


    const validate = () => {
        service.name = service.name.trim();
        if (!service.name) {
            Notifier.showError("Δεν έχετε πληκτρολογήσει όνομα για το είδος υπηρεσίας!");
            setFocusTo('name');
            return false;
        }

        // check duration and notification days
        if (service.type == SERVICE_TYPE.SUBSCRIPTION) {
            if (service.duration < 1) {
                Notifier.showError("Δεν έχετε ορίσει την διάρκεια συνδρομής!");
                setFocusTo('duration');
                return false;
            }


            maxNotificationDays = (service.duration ? service.duration : 0) * 30;

            notificationTypes.map(item => {
                if (item.days_before && item.days_before >= maxNotificationDays) {
                    Alert.alert("Ενημέρωση υπηρεσίας", "Η διάρκεια της υπηρεσίας είναι μικρότερη από τις ημέρες αποστολής κάποιων ειδοποιήσεων λήξης!");
                    return false;
                }
            })
        }

        return true;
    }


    initialize();

    // Object.keys(SERVICE_TYPE).map(key => {
    //     serviceTypes.push({
    //         name: SERVICE_TYPES[SERVICE_TYPE[key]], value: SERVICE_TYPE[key]
    //     });
    // })

    $: {
        if (service && service.type == SERVICE_TYPE.SUBSCRIPTION) {
            maxNotificationDays = (service.duration ? service.duration : 0) * 30;
        }
    }
</script>

<Breadcrumb {breadcrumb}/>
{#if service}
    <PageHeader title="{ serviceName }"/>
    <div class="row">
        <div class="col-lg-4">
            <div class="panel panel-default box-border">
                <div class="panel-body panel-pad">
                    <div class="form-group">
                        <label>Όνομα</label>
                        <div class="input-group">
                            <input type="text" class="form-control" id="name" bind:value="{ service.name }"
                                   required>
                            <InputGroupColor bind:value="{ service.color }" label="{ acronym(service.name) }"
                                             rounded/>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Είδος υπηρεσίας</label>
                        <select class="form-select" bind:value="{ service.type }" on:change={ onTypeChange }>
                            {#each Object.keys(SERVICE_TYPE) as key}
                                <option value="{SERVICE_TYPE[key]}">{ SERVICE_TYPES[SERVICE_TYPE[key]] }</option>
                            {/each}
                        </select>
                    </div>
                    {#if service.type == SERVICE_TYPE.SUBSCRIPTION}
                        <div class="form-group">
                            <label>Διάστημα (μήνες)</label>
                            <input type="number" class="form-control" id="duration" bind:value="{ service.duration }"
                                   placeholder="μήνες" required>
                        </div>
                    {/if}
                    <hr>
                    <div class="row">
                        <div class="col">

                        </div>
                        <div class="col text-end">
                            <button class="btn btn-primary" on:click={ save }>ΕΝΗΜΕΡΩΣΗ</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="panel panel-default mb-4">
                <div class="panel-heading">
                    <div class="title-sm">Πεδία</div>
                </div>
                <div class="panel-body panel-pad">
                    <WsServiceFields {serviceId} bind:fields="{ service.fields }"/>
                </div>
            </div>
            {#if service.type == SERVICE_TYPE.SUBSCRIPTION}
                <div class="panel panel-default mb-4">
                    <div class="panel-heading">
                        <div class="title-sm">Ειδοποιήσεις</div>
                    </div>
                    <div class="panel-body panel-pad">
                        {#if service.id == 0}
                            <p>
                                Αποθηκεύστε την νέα υπηρεσία για να επεξεργαστείτε τις ειδοποιήσεις.
                            </p>
                        {:else}
                            <ul class="list-group">
                                {#each notificationTypes as item}
                                    <li class="list-group-item d-flex align-items-center justify-content-between">

                                        <div class="is-link" class:text-gray={ item.id == 0 }
                                             class:not-active={ item.id > 0 && !item.is_active }
                                             on:click={ () => onEditNotification(item) }>

                                            {#if item.days_before && maxNotificationDays <= item.days_before}
                                                <AppIcon icon="alert-triangle" inline cssClass="mr-2"/>
                                            {/if}
                                            { item.name }
                                        </div>

                                        {#if item.id > 0}
                                            <div>
                                                {#if item.days_before}
                                                    ({ item.days_before } ημέρες)
                                                {/if}
                                            </div>
                                            <button class="btn btn-default" title="διαγραφή ειδοποίησης"
                                                    on:click={ () => onDeleteNotification(item) }>
                                                <AppIcon icon="trash"/>
                                            </button>
                                        {/if}
                                    </li>
                                {/each}
                            </ul>
                        {/if}
                    </div>
                </div>
            {/if}
        </div>
    </div>
{/if}

{#if notificationType != null}
    <WsServiceNotificationModal {serviceId} {notificationType} closeCallback="{ closeNotification }"/>
{/if}